import { styled } from "@mui/material/styles";
import {
    Avatar,
    Box,
    ListItemAvatar,
    ListItemButton,
    Stack,
    Typography,
} from "@mui/material";
import { TEXT_ELLIPSIS } from "@shared/styles";

export const AvatarContainer = styled("div")({
    position: "relative",
    "& > svg": {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: "auto",
    },
});

export const ListItemAvatarContainer = styled(ListItemAvatar)({
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    marginTop: "6px",
    marginRight: "12px",
    minWidth: "unset",
});

export const AvatarStyled = styled(Avatar)({
    width: "40px",
    height: "40px",
});

export const TypographyHeaderSubTitleBox = styled(Box)({
    fontSize: "12px",
    color: "var(--community-color-secondary-text)",
    lineHeight: 1.5,
    whiteSpace: "nowrap",
});

export const ListItemButtonContainer = styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== "showHover",
})<{ showHover?: boolean }>(({ showHover = true }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    backgroundColor: "var(--community-color-snow-white)",
    "&:hover": {
        backgroundColor: showHover
            ? "var(background-color: var(--community-color-transparent-black-05);)"
            : "transparent",
    },
    padding: "8px 16px",
}));

export const ListItemTextRelatedPost = styled(Typography)({
    fontSize: "12px",
    fontWeight: 400,
    color: "var(--community-color-secondary-text)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginBottom: "4px",
    marginTop: "4px",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    paddingLeft: "8px",
    borderLeft: "2px solid var(--community-color-iris-orchid)",
});

export const ListItemMainSection = styled(Stack)({
    flexDirection: "row",
    width: "100%",
});

export const ListItemTextHeadline = styled(Typography)({
    fontSize: "14px",
    fontWeight: 700,
    color: "var(--community-color-primary-text)",
    ...TEXT_ELLIPSIS,
});

export const ListItemTextSubline = styled(Typography)({
    fontSize: "14px",
    fontWeight: 400,
    color: "var(--community-color-primary-text)",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
});
